import React from 'react'
import cx from 'classnames'

export const Pill = ({
  label,
  onClose
}) => (
  <div className='pill'>
    <span>{label}</span>
    <img className="pill-close" src={require('../../images/close-icon.svg')} onClick={onClose} />
  </div>
)

export const Option = ({
  label,
  selected,
  hovered,
  onToggle,
  onMouseOver,
  onMouseOut,
  disabled,
  subLabel,
  subLabelWarning = false
}) => (
  <div
    className={cx('option', { selected, hovered, disabled })}
    onClick={onToggle}
    {...{ onMouseOver, onMouseOut }}
  >
    <input type='checkbox' checked={selected} />

    <p className='label'>{label}</p>
    <p className={cx('sub-label', { 'warning': subLabelWarning })}>{subLabel}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/multi-select/multi-select-parts.js